import React from "react";
import { Button, IconButton, TextField, Typography } from "@mui/material";
import { NavigateNext, NavigateBefore } from "@mui/icons-material";

// max pages to show on page navigator, 2 on left and 2 on right
const maxPages = 2;
export default function PageNavigator({
  totalPages,
  setPage,
  page,
  setLimit,
  limit,
}) {
  // local input state so we only apply changes on blur or Enter
  const DEFAULT_LIMIT = 10;
  const MAX_LIMIT = 999;
  const [localLimit, setLocalLimit] = React.useState(
    limit !== undefined && limit !== null && limit !== "" ? String(limit) : String(DEFAULT_LIMIT)
  );

  React.useEffect(() => {
    setLocalLimit(limit !== undefined && limit !== null && limit !== "" ? String(limit) : String(DEFAULT_LIMIT));
  }, [limit]);

  const applyLimit = () => {
    let val = String(localLimit || "").replace(/\D/g, "");
    if (val === "") val = String(DEFAULT_LIMIT);
    // clamp
    let n = parseInt(val, 10) || DEFAULT_LIMIT;
    if (n < 1) n = 1;
    if (n > MAX_LIMIT) n = MAX_LIMIT;
    setLimit(n);
    setPage(1);
    setLocalLimit(String(n));
  };

  const onLocalChange = (e) => {
    // keep only digits and max 3 chars
    const digits = String(e.target.value || "").replace(/\D/g, "").slice(0, 3);
    setLocalLimit(digits);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      applyLimit();
    }
  };
  return (
    <div className="mt-4 flex justify-end gap-1">
      <Typography className="mr-1 self-center">Rows per page:</Typography>
      <div className="w-20 shrink">
        <TextField
          type="text"
          value={localLimit}
          onChange={onLocalChange}
          onBlur={applyLimit}
          onKeyDown={onKeyDown}
          size="small"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 3 }}
        />
      </div>

      <IconButton
        onClick={() => setPage(page - 1)}
        disabled={page === 1}
        className="self-center"
      >
        <NavigateBefore />
      </IconButton>

      {Array.from({ length: totalPages }, (_, index) => index).map((_, i) => {
        if (page - maxPages <= i + 1 && i <= maxPages + page)
          return (
            <Button
              size="small"
              variant={i === page - 1 ? "contained" : "text"}
              color={i === page - 1 ? "primary" : "inherit"}
              key={i}
              onClick={() => setPage(i + 1)}
            >
              {i + 1}
            </Button>
          );
        else return null;
      })}
      <IconButton
        onClick={() => setPage(page + 1)}
        disabled={page === totalPages}
        className="self-center"
        sx={{
          backgroundColor: page === totalPages ? "" : "primary.main",
          color: page === totalPages ? "" : "primary.contrastText",
        }}
      >
        <NavigateNext />
      </IconButton>
    </div>
  );
}
